// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageTextContent_content__EWAEQ {
  padding: 8px;
  color: #272A36;
  word-break: break-word;
}
.MessageTextContent_content__EWAEQ a {
  text-decoration: none;
  font-weight: 400;
  transition: 0.2s all;
  color: #272A36;
}
.MessageTextContent_content__EWAEQ a:hover {
  color: #4778EE;
}

.MessageTextContent_attributes__1LlsL {
  margin-left: 6px;
  float: right;
  margin-top: auto;
  position: relative;
  top: 3px;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/MessageGroup/Content/MessageTextContent/MessageTextContent.module.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,cAJM;EAKN,sBAAA;AADF;AAKE;EACE,qBAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAbI;AAUR;AAKI;EACE,cAAA;AAHN;;AAQA;EAEE,gBAAA;EAEA,YAAA;EACA,gBAAA;EAEA,kBAAA;EACA,QAAA;AARF","sourcesContent":["$color: #272A36;\n\n.content {\n  padding: 8px;\n  color: $color;\n  word-break: break-word;\n  //display: flex;\n  //justify-content: space-between;\n\n  a {\n    text-decoration: none;\n    font-weight: 400;\n    transition: 0.2s all;\n    color: $color;\n\n    &:hover {\n      color: #4778EE;\n    }\n  }\n}\n\n.attributes {\n  //flex-shrink: 0;\n  margin-left: 6px;\n\n  float: right;\n  margin-top: auto;\n\n  position: relative;\n  top: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `MessageTextContent_content__EWAEQ`,
	"attributes": `MessageTextContent_attributes__1LlsL`
};
export default ___CSS_LOADER_EXPORT___;
